import { canDisplayAzureAdBecauseEnabled } from '@app/pages/permissions'
import { rbacCapabilityCheckAllOf } from '@libs/rbac/functions'
import {
  deny,
  readIdentityExplorer
} from '@libs/rbac/permissions'

export const canAccessToIdentityExplorer = rbacCapabilityCheckAllOf(
  canDisplayAzureAdBecauseEnabled,
  readIdentityExplorer(),
  deny()
)
